import { Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { NavigationLockService } from '@core/services/navigation-lock.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoadingService } from '@core/services/loading.service';

@Directive({
  selector: '[appNavigationDisable]',
})
export class NavigationDisableDirective implements OnDestroy {
  private destroying = new Subject();
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private navigationLockService: NavigationLockService,
    private loadingService: LoadingService,
  ) {
    this.navigationLockService
      .isNavigating()
      .pipe(takeUntil(this.destroying))
      .subscribe((isNavigating) => {
        if (isNavigating) {
          this.disableElement();
        } else {
          this.enableElement();
        }
      });

    this.loadingService.loadingState
      .pipe(takeUntil(this.destroying))
      .subscribe((isLoading) => {
        if (isLoading) {
          this.disableElement();
        } else {
          this.enableElement();
        }
      });
  }

  ngOnDestroy() {
    this.destroying.next();
  }

  private disableElement() {
    if (this.el.nativeElement.tagName === 'A') {
      this.renderer.setStyle(this.el.nativeElement, 'pointer-events', 'none');
    } else {
      this.renderer.setProperty(this.el.nativeElement, 'disabled', true);
    }
  }

  private enableElement() {
    if (this.el.nativeElement.tagName === 'A') {
      this.renderer.setStyle(this.el.nativeElement, 'pointer-events', 'auto');
    } else {
      this.renderer.setProperty(this.el.nativeElement, 'disabled', false);
    }
  }
}
